import InputSearch from "../../inputs/InputSearch";
import TableAdmin from "../../Tables/TableAdmin";
import { useAdminGetAdminsListQuery } from "../../../services/organization/settings";
import InviteAdminModal from "../../Modals/InviteAdminModal";
import { useState, useEffect } from "react";
import Pagination from "../../Tables/Pagination";
import { useTranslation } from "react-i18next";
import EmptyState from "../../EmptyState";
import Icon from "../../icons/Icon";
import { UsersStrokeIcon } from "../../icons/Icons";

const SiteAdministration = () => {
  const [page, setPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const { data: adminsList } = useAdminGetAdminsListQuery({
    searchKeyword: searchKeyword,
    page,
  });
  const { t } = useTranslation("settings");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const admins = adminsList?.data || [];
  const hasAdmins = admins.length > 0;
  const isSearching = searchKeyword.trim().length > 0;

  return (
    <div className="py-4 site-administration">
      <InviteAdminModal />

      <div className="header-table">
        <div className="d-flex flex-wrap align-items-center justify-content-between admin-settings__admins-toolbar">
          <div className="left-side admin-settings__admins-heading">
            <h3 className="font_20 font-extrabold ">
              {t("settings:admins", { number: admins.length })}
            </h3>
            <p className="font_16 font-color-grey">
              {t("settings:addAdminHint")}
            </p>
          </div>

          <div className="right-side admin-settings__admins-actions">
            <ul className="list-filter">
              <li>
                <InputSearch
                  placeHolder={t("settings:adminSearch")}
                  value={searchKeyword}
                  onChange={(e) => {
                    setPage(1);
                    setSearchKeyword(e.target.value);
                  }}
                />
              </li>

              <li>
                <button
                  type="button"
                  className="btn btn-main-color font-15"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdropAdmin"
                >
                  <span className="fas fa-user-plus fa-fw me-2"></span>
                  {t("settings:adminInvite")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-3">
        {hasAdmins ? (
          <>
            <TableAdmin usersList={adminsList} />
            <Pagination
              current={adminsList?.pagination?.current}
              pages={adminsList?.pagination?.pages}
              handlePagination={(nextPage) => setPage(nextPage)}
            />
          </>
        ) : (
          <div className="admin-settings__admins-empty">
            <EmptyState
              iconComponent={
                <Icon
                  icon={<UsersStrokeIcon />}
                  iconName="users"
                  iconSize={38}
                  viewBox="0 0 25 25"
                  iconColor="#bbbabf"
                  hasStroke
                />
              }
              title={
                isSearching
                  ? t("settings:noSearchResults")
                  : t("settings:emptyAdmins")
              }
              emptyStateText={
                isSearching
                  ? t("settings:noSearchResultsHint")
                  : t("settings:emptyAdminsHint")
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteAdministration;
